(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mastoner-availability-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mastoner-delivery-estimate')) {
    class MastonerDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        this.update();
        this.interval = window.setInterval(() => this.update(), 30000);
      }

      disconnectedCallback() {
        if (this.interval) window.clearInterval(this.interval);
      }

      update() {
        const estimate = this.getEstimate(Number.parseInt(this.dataset.cutoffHour || '14', 10));
        const locale = this.dataset.locale || document.documentElement.lang || 'es-ES';
        const dateTarget = this.querySelector('[data-delivery-date]');
        const cutoffTarget = this.querySelector('[data-delivery-cutoff]');

        if (!dateTarget || !cutoffTarget) return;

        dateTarget.textContent = this.formatDate(estimate.deliveryDate, locale);

        let template = this.dataset.afterText;
        if (estimate.isWeekend) template = this.dataset.weekendText;
        if (estimate.beforeCutoff) template = this.dataset.beforeText;

        cutoffTarget.replaceChildren();

        if (template) {
          cutoffTarget.replaceChildren(...this.renderTemplate(template, estimate.remaining));
          cutoffTarget.hidden = false;
        } else {
          cutoffTarget.hidden = true;
        }

        this.hidden = false;
      }

      getEstimate(cutoffHour) {
        const now = new Date();
        const today = this.startOfDay(now);
        const cutoff = new Date(today);
        cutoff.setHours(cutoffHour, 0, 0, 0);

        const isWeekend = !this.isBusinessDay(today);
        const beforeCutoff = !isWeekend && now < cutoff;
        let deliveryDate;
        let remainingTarget;

        if (beforeCutoff) {
          deliveryDate = this.addBusinessDays(today, 1);
          remainingTarget = cutoff;
        } else if (isWeekend) {
          const nextBusinessDay = this.nextBusinessDay(today);
          deliveryDate = this.addBusinessDays(nextBusinessDay, 1);
          remainingTarget = new Date(nextBusinessDay);
          remainingTarget.setHours(cutoffHour, 0, 0, 0);
        } else {
          deliveryDate = this.addBusinessDays(today, 2);
          remainingTarget = this.nextBusinessDay(today);
          remainingTarget.setHours(cutoffHour, 0, 0, 0);
        }

        return {
          beforeCutoff,
          isWeekend,
          deliveryDate,
          remaining: this.formatRemaining(Math.max(0, remainingTarget.getTime() - now.getTime()))
        };
      }

      startOfDay(date) {
        const copy = new Date(date);
        copy.setHours(0, 0, 0, 0);
        return copy;
      }

      isBusinessDay(date) {
        const day = date.getDay();
        return day !== 0 && day !== 6;
      }

      nextBusinessDay(date) {
        const next = new Date(date);
        do {
          next.setDate(next.getDate() + 1);
        } while (!this.isBusinessDay(next));
        return next;
      }

      addBusinessDays(date, days) {
        const next = new Date(date);
        let added = 0;

        while (added < days) {
          next.setDate(next.getDate() + 1);
          if (this.isBusinessDay(next)) added += 1;
        }

        return next;
      }

      formatDate(date, locale) {
        const parts = new Intl.DateTimeFormat(locale, {
          weekday: 'long',
          day: '2-digit',
          month: '2-digit'
        }).formatToParts(date);
        const weekday = parts.find((part) => part.type === 'weekday')?.value || '';
        const day = parts.find((part) => part.type === 'day')?.value || '';
        const month = parts.find((part) => part.type === 'month')?.value || '';

        return `${weekday} ${day}/${month}`.trim();
      }

      formatRemaining(milliseconds) {
        const totalMinutes = Math.ceil(milliseconds / 60000);
        const days = Math.floor(totalMinutes / 1440);
        const hours = Math.floor((totalMinutes % 1440) / 60);
        const minutes = totalMinutes % 60;
        const parts = [];

        if (days > 0) parts.push(`${days}d`);
        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0 || parts.length === 0) parts.push(`${minutes}min`);

        return parts.join(' ');
      }

      renderTemplate(template, remaining) {
        const text = (template || '').replace('[time]', remaining);
        const nodes = [];

        if (!text.includes(remaining)) return [document.createTextNode(text)];

        const parts = text.split(remaining);
        nodes.push(document.createTextNode(parts[0] || ''));

        const strong = document.createElement('strong');
        strong.textContent = remaining;
        nodes.push(strong);
        nodes.push(document.createTextNode(parts.slice(1).join(remaining)));

        return nodes;
      }
    }

    customElements.define('mastoner-delivery-estimate', MastonerDeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mastoner-product-shipping-band"] && !Shopify.designMode) return;
  try {
    document.addEventListener('on:variant:change', (event) => {
  const scope = event.target.closest('.js-product');
  if (!scope) return;
  const variantId = event.detail?.variant?.id;
  scope.querySelectorAll('[data-product-shipping-band]').forEach((band) => {
    band.hidden = !variantId || !band.dataset.eligibleVariants.includes(`|${variantId}|`);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mastoner-promotion-card-label"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mastoner-promotion-card-label')) {
    const madrid = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
    const partsAt = (epoch) => Object.fromEntries(madrid.formatToParts(new Date(epoch)).map(({ type, value }) => [type, value]));
    const validDay = (value) => {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value ?? '')) return false;
      const epoch = Date.parse(value + 'T00:00:00.000Z');
      return Number.isFinite(epoch) && new Date(epoch).toISOString().slice(0, 10) === value;
    };
    const afterEndDay = (value) => {
      const [year, month, day] = value.split('-').map(Number);
      const desired = Date.UTC(year, month - 1, day + 1);
      let epoch = desired;
      for (let iteration = 0; iteration < 3; iteration += 1) {
        const p = partsAt(epoch);
        epoch += desired - Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), Number(p.hour), Number(p.minute), Number(p.second));
      }
      return epoch;
    };
    customElements.define('mastoner-promotion-card-label', class extends HTMLElement {
      connectedCallback() {
        this.onVisibility = () => this.reconcile();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.reconcile();
      }
      disconnectedCallback() {
        clearTimeout(this.expiryTimer);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
      reconcile() {
        clearTimeout(this.expiryTimer);
        const data = this.dataset;
        const now = Date.now();
        const p = partsAt(now);
        const today = `${p.year}-${p.month}-${p.day}`;
        const fresh = Date.parse(data.freshUntil ?? '');
        const valid = data.contractVersion === 'mastoner-promotion-publication.v1' &&
          data.state === 'active' && Boolean(data.providerId?.trim()) &&
          Boolean(data.supplierSku?.trim()) && Boolean(data.promotionCode?.trim()) &&
          /^[a-f0-9]{64}$/.test(data.pricingDecisionHash ?? '') &&
          validDay(data.startsOn) && validDay(data.endsOn) &&
          today >= data.startsOn && today <= data.endsOn && fresh > now;
        this.hidden = !valid;
        if (valid) {
          const expiresAt = Math.min(fresh, afterEndDay(data.endsOn));
          this.expiryTimer = setTimeout(() => this.reconcile(), Math.min(2147483647, Math.max(1, expiresAt - now)));
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mastoner-quick-facets"] && !Shopify.designMode) return;
  try {
    class MastonerQuickFacets {
  constructor(container) {
    this.container = container;
    this.links = [...container.querySelectorAll('[data-mastoner-filter-tag]')];
    this.sync();
    this.groupLinks();
  }

  groupLinks() {
    if (!this.container.classList.contains('mastoner-quick-facets--grouped')) return;
    if (this.container.dataset.mastonerGrouped === 'true') return;

    const sourceList = [...this.container.children].find((child) => child.classList?.contains('mastoner-quick-facets__list'));
    if (!sourceList) return;

    const groups = new Map();
    const fragment = document.createDocumentFragment();

    [...sourceList.children].forEach((item) => {
      const groupLabel = this.filterGroupLabel(item);
      let group = groups.get(groupLabel);

      if (!group) {
        const wrapper = document.createElement('div');
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const summaryLabel = document.createElement('span');
        const chevron = document.createElement('span');
        const panel = document.createElement('div');
        const list = document.createElement('ul');

        wrapper.className = 'mastoner-quick-facets__group';
        details.className = 'mastoner-quick-facets__details';
        summary.className = 'mastoner-quick-facets__group-toggle';
        summaryLabel.textContent = groupLabel;
        chevron.className = 'mastoner-quick-facets__chevron';
        chevron.setAttribute('aria-hidden', 'true');
        panel.className = 'mastoner-quick-facets__panel';
        list.className = 'mastoner-quick-facets__list';
        list.setAttribute('role', 'list');

        summary.append(summaryLabel, chevron);
        panel.append(list);
        details.append(summary, panel);
        wrapper.append(details);
        fragment.append(wrapper);

        group = { details, list };
        groups.set(groupLabel, group);
      }

      if (item.querySelector('.mastoner-quick-facets__link.is-active')) {
        group.details.open = true;
      }

      item.removeAttribute('data-mastoner-filter-group');
      group.list.append(item);
    });

    sourceList.replaceWith(fragment);
    this.container.dataset.mastonerGrouped = 'true';
  }

  filterGroupLabel(item) {
    if (item.dataset.mastonerFilterGroup) return item.dataset.mastonerFilterGroup;

    const tag = item.querySelector('[data-mastoner-filter-tag]')?.dataset.mastonerFilterTag || '';
    const groupLabels = [
      ['mf-use', 'Uso'],
      ['mf-feature', 'Caracteristicas'],
      ['mf-print-duplex', 'Caracteristicas'],
      ['mf-scan-duplex', 'Caracteristicas'],
      ['mf-tray', 'Caracteristicas'],
      ['mf-cpu', 'Procesador'],
      ['mf-ram', 'Memoria RAM'],
      ['mf-pc-storage', 'Almacenamiento'],
      ['mf-storage-family', 'Tipo'],
      ['mf-storage-type', 'Formato'],
      ['mf-storage-capacity', 'Capacidad'],
      ['mf-screen', 'Tamano'],
      ['mf-resolution', 'Resolucion'],
      ['mf-os', 'Sistema operativo'],
      ['mf-monitor-panel', 'Panel'],
      ['mf-monitor', 'Caracteristicas'],
      ['mf-ink-type', 'Tipo de tinta'],
      ['mf-peripheral', 'Tipo'],
      ['mf-network', 'Velocidad'],
      ['mf-ports', 'Puertos'],
      ['mf-printer-brand', 'Fabricante / marca impresora'],
      ['mf-origin', 'Original / compatible'],
      ['mf-function', 'Tipo'],
      ['mf-equipment', 'Tipo'],
      ['mf-consumable', 'Tipo de consumible'],
      ['mf-support', 'Soporte'],
      ['mf-finish', 'Acabado'],
      ['mf-format', 'Formato'],
      ['mf-width', 'Ancho'],
      ['mf-size', 'Medida'],
      ['mf-material', 'Material'],
      ['mf-diameter', 'Diametro'],
      ['mf-weight', 'Peso'],
      ['mf-tech', 'Tecnologia'],
      ['mf-color-mode', 'Color'],
      ['mf-color', 'Color'],
      ['mf-duplex', 'Doble cara'],
      ['mf-connection', 'Conexion'],
    ];
    const match = groupLabels.find(([prefix]) => tag.startsWith(`${prefix}-`));
    return match ? match[1] : 'Otros';
  }

  tagGroup(tag) {
    if (tag.startsWith('mf-monitor-panel-')) return 'mf-monitor-panel';
    if (/^mf-monitor-\d+hz$/.test(tag)) return 'mf-monitor-refresh';
    if (tag.startsWith('mf-monitor-')) return tag;

    const groups = [
      'mf-width',
      'mf-format',
      'mf-support',
      'mf-finish',
      'mf-material',
      'mf-diameter',
      'mf-weight',
      'mf-size',
      'mf-use',
      'mf-feature',
      'mf-print-duplex',
      'mf-scan-duplex',
      'mf-tray',
      'mf-cpu',
      'mf-ram',
      'mf-pc-storage',
      'mf-storage-family',
      'mf-storage-type',
      'mf-storage-capacity',
      'mf-screen',
      'mf-resolution',
      'mf-os',
      'mf-monitor-panel',
      'mf-monitor',
      'mf-ink-type',
      'mf-peripheral',
      'mf-network',
      'mf-ports',
      'mf-printer-brand',
      'mf-origin',
      'mf-tech',
      'mf-color-mode',
      'mf-color',
      'mf-duplex',
      'mf-consumable',
      'mf-equipment',
      'mf-function'
    ];

    return groups.find((group) => tag.startsWith(`${group}-`)) || '';
  }

  nextTags(activeTags, tag, active) {
    if (active) return activeTags.filter((activeTag) => activeTag !== tag);

    const group = this.tagGroup(tag);
    const cleanedTags = group
      ? activeTags.filter((activeTag) => this.tagGroup(activeTag) !== group)
      : activeTags;

    return [...cleanedTags, tag];
  }

  sync() {
    const currentUrl = new URL(window.location.href);
    const collectionPath = this.container.dataset.collectionUrl.replace(/\/$/, '');
    const currentPath = decodeURIComponent(currentUrl.pathname).replace(/\/$/, '');
    const tagPath = currentPath.startsWith(`${collectionPath}/`)
      ? currentPath.slice(collectionPath.length + 1)
      : '';
    const activeTags = tagPath ? tagPath.split('+').filter(Boolean).map(decodeURIComponent) : [];

    this.links.forEach((link) => {
      const tag = link.dataset.mastonerFilterTag;
      const active = activeTags.includes(tag);
      const nextUrl = new URL(window.location.href);
      const nextTags = this.nextTags(activeTags, tag, active);

      nextUrl.pathname = nextTags.length ? `${collectionPath}/${nextTags.join('+')}` : collectionPath;
      nextUrl.searchParams.delete('page');
      link.href = `${nextUrl.pathname}${nextUrl.search}`;
      link.classList.toggle('is-active', active);
      link.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
}

document.querySelectorAll('.mastoner-quick-facets').forEach((container) => {
  new MastonerQuickFacets(container);
});
  } catch(e) { console.error(e); }
})();

})();
